import type { LucideIcon } from 'lucide-react';
import {
  Car,
  Building2,
  Smartphone,
  Briefcase,
  Bike,
  Tv,
  Shirt,
  Sofa,
  Wrench,
  PawPrint,
  Users,
  Store,
  Tags,
  Home,
  ShoppingBag,
  Truck,
  Bus,
  Cog,
  CircleDot,
} from 'lucide-react';

// Map category slugs to Lucide icons
export const CATEGORY_ICON_MAP: Record<string, LucideIcon> = {
  // Cars & Vehicles
  'cars': Car,
  'cars-vehicles': Car,
  'motorbikes-scooters': Bike,
  'vans-buses': Bus,
  'trucks-heavy-vehicles': Truck,
  'auto-parts-accessories': Cog,
  'other-vehicles': CircleDot,
  
  // Property
  'property': Building2,
  'property-for-sale': Building2,
  'property-for-rent': Home,
  
  // Mobiles & Electronics
  'mobiles': Smartphone,
  'electronics': Tv,
  'for-sale': Tags,
  
  // Jobs
  'jobs': Briefcase,
  
  // Services
  'services': Wrench,
  
  // Pets
  'pets': PawPrint,
  
  // Community
  'community': Users,
  
  // Store/Business
  'store': Store,
  
  // Fashion
  'fashion': Shirt,
  'fashion-sell': Shirt,
  
  // Furniture/Home
  'furniture': Sofa,
  'home-living': Home,
  
  // Default fallback
  'default': ShoppingBag,
};

// Map category names to gradients
export const CATEGORY_GRADIENT_MAP: Record<string, string> = {
  'cars': 'from-red-500 to-rose-600',
  'cars-vehicles': 'from-red-500 to-rose-600',
  'motorbikes-scooters': 'from-cyan-500 to-blue-600',
  'vans-buses': 'from-blue-500 to-indigo-600',
  'trucks-heavy-vehicles': 'from-orange-500 to-amber-600',
  'auto-parts-accessories': 'from-gray-500 to-slate-600',
  'other-vehicles': 'from-purple-500 to-violet-600',
  
  'property': 'from-emerald-500 to-teal-600',
  'property-for-sale': 'from-emerald-500 to-teal-600',
  'property-for-rent': 'from-green-500 to-emerald-600',
  
  'for-sale': 'from-violet-500 to-purple-600',
  'mobiles': 'from-violet-500 to-purple-600',
  'electronics': 'from-blue-500 to-indigo-600',
  
  'jobs': 'from-amber-500 to-orange-600',
  'services': 'from-orange-500 to-red-500',
  'pets': 'from-pink-500 to-rose-500',
  'community': 'from-indigo-500 to-purple-600',
  'store': 'from-teal-500 to-cyan-600',
  'fashion': 'from-pink-500 to-rose-600',
  'furniture': 'from-orange-500 to-amber-600',
  
  'default': 'from-primary-500 to-primary-600',
};

export const getCategoryIcon = (slug: string): LucideIcon => {
  return CATEGORY_ICON_MAP[slug] || CATEGORY_ICON_MAP['default'];
};

export const getCategoryGradient = (slug: string): string => {
  return CATEGORY_GRADIENT_MAP[slug] || CATEGORY_GRADIENT_MAP['default'];
};

// Normalize category slug for matching
export const normalizeCategorySlug = (slug: string): string => {
  return slug.toLowerCase().trim();
};
